export type EnvironmentName = 'local' | 'development' | 'staging' | 'production';

export interface AppEnvironment {
  name: EnvironmentName;
  production: boolean;
  supabaseUrl: string;
  supabaseAnonKey: string;
  expectedProjectRef: string | null;
  passwordRecoveryRedirectUrl: string;
}

export function assertValidEnvironment(config: AppEnvironment): void {
  const placeholder = /REPLACE_WITH_|example\.supabase\.co/i;

  if (!config.supabaseUrl || !config.supabaseAnonKey || placeholder.test(config.supabaseUrl) || placeholder.test(config.supabaseAnonKey)) {
    throw new Error(`Configuration Supabase incomplète pour l'environnement ${config.name}.`);
  }

  assertValidRecoveryRedirectUrl(config.passwordRecoveryRedirectUrl, config.name);

  const projectRef = getSupabaseProjectRef(config.supabaseUrl);
  if (config.expectedProjectRef && projectRef !== config.expectedProjectRef) {
    throw new Error(
      `Connexion Supabase croisée refusée : ${config.name} attend ${config.expectedProjectRef}, reçu ${projectRef ?? 'URL invalide'}.`
    );
  }
}

function getSupabaseProjectRef(url: string): string | null {
  try {
    const hostname = new URL(url).hostname;
    const match = hostname.match(/^([a-z0-9]+)\.supabase\.co$/i);
    return match?.[1] ?? null;
  } catch {
    return null;
  }
}

function assertValidRecoveryRedirectUrl(url: string, environmentName: EnvironmentName): void {
  try {
    const parsed = new URL(url);
    if (!['http:', 'https:'].includes(parsed.protocol) || parsed.pathname !== '/reset-password') {
      throw new Error('invalid recovery redirect');
    }
  } catch {
    throw new Error(`URL de récupération de mot de passe invalide pour l'environnement ${environmentName}.`);
  }
}
